import { ForwardedRef, RefCallback } from "react";

/** 合并ref */
export const mergeRefs = <T>(...refs: ForwardedRef<T>[]): RefCallback<T> => {
	return (node: T | null) => {
		refs.forEach((ref) => {
			if (typeof ref === 'function') {
				ref(node);
			} else if (ref !== null) {
				(ref as React.MutableRefObject<T | null>).current = node;
			}
		});
	};
};
